export const misc = {
  tileShadow: '0 4px 14px 0 rgba(0, 0, 0, .03)',
  tileBRadius: '5px',
};
